









import { PinResetMixin } from '@/mixins/pinResetMixin'

export default PinResetMixin.extend({
  name: 'ResetPinInit',

  created () {
    this.authorizeInit()
  },

  methods: {
    authorizeInit () {
      const appId = this.$route.params.appId
      this.setResetPinAppIdInStorage(appId)

      window.location.href = this.getResetPinInitUrl()
    }
  }
})
